import { cva, VariantProps } from 'class-variance-authority';
import { cn } from '@/components/ui/utils';
import { useLocation, useNavigate } from 'react-router-dom';
import { TappIcon } from '../TappIcon';
import { useTappSidebar } from '../TappSidebar/sidebar.hook';
import { Button } from '../button';

const styles = cva('', {
  variants: {},
  defaultVariants: {},
});

export type TappPageHeaderProps = {
  title: string;
  defaultBack?: boolean;
  backLink?: string;
  actions?: React.ReactNode;
} & VariantProps<typeof styles> &
  React.ComponentProps<'header'>;

export const TappPageHeader: React.FC<TappPageHeaderProps> = ({
  title,
  defaultBack,
  backLink,
  actions,
  className,
  ...props
}) => {
  history;
  const navigate = useNavigate();
  const location = useLocation();
  const hasDefaultBack = location.key !== 'default';
  const sidebar = useTappSidebar();

  return (
    <header
      className={cn(
        'sticky top-0 z-10 -mx-4 -mt-4 mb-4 flex h-20 flex-row items-center border-b border-border bg-background px-4 transition-all duration-500 md:-mx-6 md:-mt-6 md:mb-6 md:px-6 lg:-mx-8 lg:-mt-8 lg:mb-8 lg:h-20 lg:px-8',
        styles({}),
        className
      )}
      {...props}
    >
      <button className="mr-6 flex items-center justify-center p-1 md:hidden" onClick={() => sidebar.toggleOpen()}>
        <TappIcon size={24}>menu</TappIcon>
      </button>
      {defaultBack && (hasDefaultBack || (!hasDefaultBack && backLink)) && (
        <Button
          size="iconSm"
          variant="outline"
          className="mr-4"
          onClick={() => {
            if (hasDefaultBack) {
              navigate(-1);
            } else if (backLink) {
              navigate(backLink);
            }
          }}
        >
          <TappIcon size={16}>arrow_back</TappIcon>
        </Button>
      )}
      <h1 className="text-xl font-semibold tracking-tight">{title}</h1>

      {actions && <div className="ml-auto flex items-center gap-2">{actions}</div>}
    </header>
  );
};
